import { Component, computed, input } from '@angular/core';
import { allPasswordConditionsMet, getPasswordConditions, PasswordCondition } from '@common/utils/password-validation';

@Component({
    selector: 'app-password-conditions',
    templateUrl: './password-conditions.component.html'
})
export class PasswordConditionsComponent {
    password = input<string>('');

    conditions = computed<PasswordCondition[]>(() => getPasswordConditions(this.password()));

    allConditionsMet = computed(() => allPasswordConditionsMet(this.password()));

    hasAnyPassword = computed(() => this.password().length > 0);
}
